module.exports = __webpack_public_path__ + "img/leaves-home-1x.bbd890cf.png";